import { isNil } from "lodash";
import type { EditableIfrsValues } from "./useSaveIfrsValues";

const isNumber = (value: number | null | undefined): value is number => Number.isFinite(value);

const isAtLeastOneMonth = (months: number | null | undefined): boolean => !isNil(months) && months >= 1;

export const hasValuesForIfrsReport = (values: EditableIfrsValues | undefined): boolean =>
  !isNil(values?.startDate) &&
  isNumber(values?.monthlyPayment) &&
  isNumber(values?.interestRate) &&
  isAtLeastOneMonth(values?.paymentIntervalInMonths) &&
  isAtLeastOneMonth(values?.contractLengthInMonths);
